import React from 'react';
import FooterTop from './FooterTop/FooterTop';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="bg-white">
      <FooterTop></FooterTop>
      <p className="text-center m-3 pb-3 text-xl">
        Copyright &copy; {year} | All Right Reserved!
      </p>
    </div>
  );
};

export default Footer;
